<template>
	<div class="ability-detail" _overflow="hidden">
		<div class="ability-detail-header" @click="routeBack">
			<i class="el-icon-arrow-left" style="margin-right: 5px; font-weight: 1000;"></i>返回
		</div>
		<div v-if="visible" _overflow="hidden" ref="irfameBox" :style="{ height: iframeMinHeight }" class="w-relative">
			<iframe
				:src="`${RESOURCE_URL}?isThumb=${false}&music_id=${musical_id}&isScreening=${true}`"
				ref="irfameBox"
				frameborder="0"
				:width="iframeSize.width"
				:height="iframeSize.height"
				:style="`transform: scale(${iframeSize.scale}); transform-origin: left top; position:absolute`"
			></iframe>
		</div>
	</div>
</template>
<script>
import { audioTypes } from './const'
const AUDIO_TYPES = {
	1: {
		ORDIDX: '1',
		NAME: '音频',
		CODE: 'VOICE1'
	},
	2: {
		ORDIDX: '2',
		NAME: '男高音',
		CODE: 'VOICE2'
	},
	3: {
		ORDIDX: '3',
		NAME: '男中音',
		CODE: 'VOICE3'
	},
	4: {
		ORDIDX: '4',
		NAME: '男低音',
		CODE: 'VOICE4'
	},
	5: {
		ORDIDX: '5',
		NAME: '女高音',
		CODE: 'VOICE5'
	},
	6: {
		ORDIDX: '6',
		NAME: '女中音',
		CODE: 'VOICE6'
	},
	7: {
		ORDIDX: '7',
		NAME: '女低音',
		CODE: 'VOICE7'
	},
	8: {
		ORDIDX: '8',
		NAME: '伴唱',
		CODE: 'BANCHANG'
	},
	9: {
		ORDIDX: '9',
		NAME: '范唱',
		CODE: 'FANCHANG'
	},
	10: {
		ORDIDX: '10',
		NAME: '演唱题-伴唱',
		CODE: 'SING_BANCHANG'
	}
}

export default {
	data() {
		return {
			RESOURCE_URL: null,
			musical_id: null,
			iframeMinHeight: '',
			iframeMarginBottom: '',
			visible: false,
			iframeSize: { width: 1920, height: 0, scale: 1 },
			audioTypes
		}
	},
	methods: {
		routeBack() {
			this.$router.push({
				name: 'exampleManage'
			})
		},
		// 计算根据缩放比和实际宽高
		getIframeSize() {
			this.$nextTick(() => {
				const size = { width: 1920, height: 0, scale: 1 }
				const irfameBox = this.$refs.irfameBox
				if (irfameBox) {
					const clientHeight = irfameBox.clientHeight
					const clientWidth = irfameBox.clientWidth
					size.scale = clientWidth / size.width
					size.height = clientHeight / size.scale
				}
				Object.assign(this.iframeSize, size)
			})
		}
	},
	mounted() {
		this.iframeMinHeight = window.innerHeight - 150 + 'px'
		document.body.style['overflow-y'] = 'hidden'
	},
	destroyed() {
		document.body.style['overflow-y'] = 'auto'
	},
	async created() {
		const { id } = this.$route.params
		this.musical_id = id
		this.RESOURCE_URL =
			window.location.hostname !== 'localhost'
				? window.web_config.server_url + window.web_config.music_score_display_path
				: window.RESOURCE_URL
		try {
			const musciData = await this.$api.question_set.getMusicalsDetail(this.musical_id)
			const { abc_json_val, music, base_info, sync_id } = musciData
			const abcContent = await this.$http({ url: abc_json_val.url })
      // 加载跟唱同步模块
      let singAlongInfo = undefined
      if (sync_id != 0) {
        await this.$api.musical_sample.querySingAlong(sync_id).then(data => {
          console.log("加载跟唱同步数据:::singAlongInfo:::", data)
          singAlongInfo = data
        })
      }
			const vocalJson = music.reduce(
				(vocalJson, item, i) => {
					let code = AUDIO_TYPES[item.audio_type]?.CODE
					// 处理自定义音频类型
					if (item.audio_type in AUDIO_TYPES === false) {
						code = `custom_${item.audio_type}`
						item['title'] = item['extra']?.['customAudio']?.['title'] || '自定义音频'
					}
					vocalJson[code + '_URL'] = music[i].file_path.url
					const new_timeline = JSON.parse(music[i].new_timeline || '{}')
					vocalJson[code + '_WXP_BARLINE'] = new_timeline?.NODELINE_WXP ? new_timeline.NODELINE_WXP : ''
          // @ts-ignore 是否显示倒计时（预备拍)
          vocalJson[`${code}_COUNTDOWN_USE_METER`] = item.extra?.countdownUseMeter
					return vocalJson
				},
				{
					ABC_CONTENT: abcContent,
					SHOW_TYPE: base_info.musicType === 'easy' ? 'jp' : 'wxp'
				}
			)
			window.top.music_datas = {}
			window.top.music_datas[this.musical_id] = {
				visibility: {
					title: true,
					subhead: true,
					anAuthor: true,
					wordAuthor: true,
					speed: true,
					attr1: true,
					attr2: true,
					singAlongTitle: true
				},
				VOCAL_JSON: vocalJson,
				abcResData: musciData,
        singAlongInfo,
				sync_json_val: musciData.sync_json_val
			}
			this.visible = true
			this.getIframeSize()
		} catch (err) {
			console.log(err, '=====')
			this.$message.error('引用的曲谱已被删除')
		}
	}
}
</script>
<style scoped lang="scss">
.ability-detail {
	background: #ffffff;
	border-radius: 8px 8px 8px 8px;
	overflow: hidden;
	height: 100%;
	.ability-detail-header {
		display: flex;
		align-items: center;
		font-size: 16px;
		padding: 15px 15px 15px 25px;
		cursor: pointer;
	}
	.ability-detail-header:hover {
		color: #ff5e2a;
	}
}
</style>
